import { useId } from 'react';
import type { ReactElement, ReactNode } from 'react';

export interface CardProps {
  title?: string;
  children: ReactNode;
  /** Layout utilities only. */
  className?: string;
}

export function Card({ title, children, className = '' }: CardProps): ReactElement {
  const titleId = useId();

  if (title) {
    return (
      <section
        aria-labelledby={titleId}
        className={`p-4 border border-solid border-line bg-panel rounded-panel font-ui m-0 ${className}`.trim()}
      >
        <h2 id={titleId} className="m-0 text-lg font-semibold text-ink mb-4">
          {title}
        </h2>
        <div>{children}</div>
      </section>
    );
  }

  return <div className={`p-4 border border-solid border-line bg-panel rounded-panel font-ui m-0 ${className}`.trim()}>{children}</div>;
}
